import { createFileRoute } from '@tanstack/react-router';
import { SecureLinkEntry } from '@/components/secure-link/secure-link-page';

/**
 * `/l#<token>`: the page a secure link opens, with no account (E12-F08,
 * E13-F05 §3.2). One entry for every purpose: Discovery's questionnaire,
 * map validation and sign-off (T-0191) and the vendor upload (T-0207).
 * The token handling (read from the fragment, cleared from the address,
 * sent only in the `X-Caliber-Link` header) lives in
 * {@link SecureLinkEntry}. The root route renders `/l` without the
 * workbench chrome.
 */
export const Route = createFileRoute('/l')({
  component: SecureLinkEntry,
});
